/** Presentation metadata only. Never use these labels as operational identifiers. */
export const researchProjects = [
  { id: "synergise", name: "SYNERGISE", grant: "101121321", url: "https://www.synergise-project.eu/" },
  { id: "foresight", name: "ForeSight", grant: "101168521", url: "https://foresight-project.eu/" },
] as const;

// Application logo use and joint attribution confirmed by the user on 2026-10-14.
// Funding artwork is attributed to its own project, never to a combined grant.
export const brandingApproval = {
  projectLogos: "confirmed-by-project-owner",
  jointDevelopmentAttribution: "confirmed-by-project-owner",
  foresightFundingLockup: "pending",
} as const;
